// Single source of truth for the running app's version and build metadata.
//
// The version comes from package.json (bumped with `npm version patch|minor|major`).
// At build time the start/build scripts inject REACT_APP_VERSION, REACT_APP_GIT_SHA
// and REACT_APP_BUILD_TIME so each deployed build carries its own identity — that is
// how we can tell which version is running on which environment.
import packageJson from '../package.json';

export const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version;
export const GIT_SHA = process.env.REACT_APP_GIT_SHA || 'dev';
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';

// Best-effort environment label derived from the host the app is served from.
// Build-time injection gives us the version; the hostname tells us *where* it runs.
export function getEnvironmentLabel() {
  if (typeof window === 'undefined') return 'unknown';
  const host = window.location.hostname || '';
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    return 'local';
  }
  if (host.includes('staging') || host.includes('stg') || host.includes('test')) {
    return 'staging';
  }
  return 'production';
}

// Compact label for the footer badge, e.g. "v2.3.51".
export const VERSION_LABEL = `v${APP_VERSION}`;

// Verbose label for tooltips / About views, e.g. "v2.3.51 · a2e9c68 · production".
export function getVersionDetails() {
  const parts = [VERSION_LABEL, GIT_SHA, getEnvironmentLabel()];
  if (BUILD_TIME) parts.push(BUILD_TIME);
  return parts.join(' · ');
}
